import { useEffect, memo, useReducer } from "react";

import { Row, Col, Form } from "react-bootstrap";

import { handleChangeReducer } from "apptools/handleChange";

function CampoDataDiviso({ id, data, onChange, hidden, disabled, label }) {
	const reducer = (state, action) => {
		switch (action.type) {
			case "DATE_SINGLE": {
				let newState = {
					...state,
					...handleChangeReducer(action.payload),
				};
				if (!!newState.day && !!newState.month && !!newState.year) {
					newState.dateFin = new Date(newState.year, newState.month, newState.day).toISOString();
					onChange(newState.dateFin);
				} else {
					newState.dateFin = null;
					onChange(null);
				}

				return newState;
			}
			case "DATE_INIT": {
				let dataNascita = new Date(action.payload);
				return {
					...state,
					day: dataNascita.getDate(),
					month: dataNascita.getMonth(),
					year: dataNascita.getFullYear(),
					dateFin: dataNascita,
				};
			}
			default:
				return state;
		}
	};
	const [state, dispatch] = useReducer(reducer, {
		day: "",
		month: "",
		year: "",
		dateFin: null,
	});

	useEffect(() => {
		if (!!data) {
			dispatch({ type: "DATE_INIT", payload: data });
		}
	}, [data, id]);

	const handleDate = (event) => {
		dispatch({
			type: "DATE_SINGLE",
			payload: event,
		});
	};

	let days = [];
	let years = [];
	let months = [];

	for (let i = 1; i <= 31; i++) {
		days.push(i);
	}
	for (let i = 1; i <= 12; i++) {
		months.push(i);
	}
	for (let i = 1920; i <= new Date().getFullYear(); i++) {
		years.push(i);
	}

	return (
		<>
			<Form.Group hidden={hidden}>
				<Form.Label>{label}</Form.Label>
				<Row>
					<Col xs={3} style={{ padding: 0 }}>
						<Form.Control
							as="select"
							type="select"
							name="day"
							value={state.day}
							required
							onChange={handleDate}
							disabled={disabled}
							isValid={false}
						>
							<option value="">gg</option>
							{days.map((k, ind) => {
								return (
									<option key={ind} value={k}>
										{k}
									</option>
								);
							})}
						</Form.Control>
						<Form.Control.Feedback type="invalid">Campo obbligatorio</Form.Control.Feedback>
					</Col>
					<Col xs={3} style={{ padding: 0 }}>
						<Form.Control
							as="select"
							type="select"
							name="month"
							value={state.month}
							required
							onChange={handleDate}
							disabled={disabled}
						>
							<option value="">mm</option>
							{months.map((k, ind) => {
								return (
									<option key={ind} value={k - 1}>
										{k}
									</option>
								);
							})}
						</Form.Control>
						<Form.Control.Feedback type="invalid">Campo obbligatorio</Form.Control.Feedback>
					</Col>
					<Col xs={6} style={{ padding: 0 }}>
						<Form.Control
							as="select"
							type="select"
							name="year"
							value={state.year}
							required
							onChange={handleDate}
							disabled={disabled}
						>
							<option value="">yyyy</option>
							{years.map((k, ind) => {
								return (
									<option key={ind} value={k}>
										{k}
									</option>
								);
							})}
						</Form.Control>
						<Form.Control.Feedback type="invalid">Campo obbligatorio</Form.Control.Feedback>
					</Col>

					<Form.Control.Feedback type="invalid">Campo obbligatorio</Form.Control.Feedback>
				</Row>
			</Form.Group>
		</>
	);
}

export default memo(CampoDataDiviso, (prevProps, nextProps) => {
	return prevProps.data === nextProps.data && prevProps.id === nextProps.id;
});
